import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import Button from "components/Buttons/Button/Button";
import Buttons from "components/Buttons/Buttons/Buttons";
import DataTable from "components/DataTable/DataTable";
import LoadingWrapper from "../../../components/Loading/LoadingWrapper";
import useAPI from "../../../hooks/useAPI";
import ProfilePage from "../ProfilePage";
import tblFields from "./tblFields.json";
import { useTranslation } from "react-i18next";
import Empty from "components/Empty/Empty";

const AddressesPage = () => {
    const { t } = useTranslation();

    const api = useAPI();
    const apiPath = "profile/company/shipping-address";

    // Load all notifications
    const { data, isLoading, refetch: refetchList } = useQuery([], () => api.list(apiPath));
    // Local state for the addresses
    const [addresses, setAddresses] = useState();

    const { data: config } = useQuery(["companyDeliveryAdressesConfig"], () => api.get("/options/profile-page/company-delivery-addresses/config"));

    useEffect(() => {
        setAddresses(data?.items);
    }, [data, setAddresses]);

    let updatedTblFields = tblFields;

    if (config?.user_can_edit_company_address_data === "1") {
        updatedTblFields = [...updatedTblFields, { field: "action", label: "", type: "edit", showOnMobile: true }];
    }

    if (config?.user_can_delete_company_address_data === "1") {
        if (config?.user_can_edit_company_address_data === "1") {
            updatedTblFields = updatedTblFields.map((field) => {
                if (field.type === "edit") return { field: "action", label: "", type: "edit_delete", refetch: refetchList, showOnMobile: true };
                return field;
            });
        } else updatedTblFields = [...updatedTblFields, { field: "action", label: "", type: "delete", showOnMobile: true }];
    }

    return (
        <ProfilePage>
            <h4 className="h-underline">{t("address_profile-default-title")}</h4>

            {config && config?.active !== "1" && <Empty message={t("global-module_locked-title")} />}
            {data && config?.active === "1" && (
                <LoadingWrapper isLoading={isLoading}>
                    {config.user_can_add_company_address_data === "1" && (
                        <Buttons align="right">
                            <Button label={t("global-default-text-New")} to="new" />
                        </Buttons>
                    )}
                    {addresses?.length > 0 ? (
                        <DataTable translateKey={"address_profile-default"} columns={updatedTblFields} data={addresses} apiUrl={apiPath} />
                    ) : (
                        <Empty message={t("address_profile-default-text-no_addresses")} />
                    )}
                </LoadingWrapper>
            )}
        </ProfilePage>
    );
};

export default AddressesPage;
